import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/i18n";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import Reviews from "@/pages/Reviews";
import BlueprintSales from "@/pages/BlueprintSales";
import BlueprintConsole from "@/pages/BlueprintConsole";
import Newsletter from "@/pages/Newsletter";
import Waitlist from "@/pages/Waitlist";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import EmailPreferences from "@/pages/EmailPreferences";
import "@/App.css";

const Shell = ({ children }) => (
  <>
    <Navbar />
    <main className="min-h-[70vh]">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <HelmetProvider>
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" />
          <Routes>
            <Route path="/" element={<Shell><Home /></Shell>} />
            <Route path="/articles" element={<Shell><Articles /></Shell>} />
            <Route path="/article/:slug" element={<Shell><ArticleDetail /></Shell>} />
            <Route path="/reviews" element={<Shell><Reviews /></Shell>} />
            <Route path="/blueprint" element={<Shell><BlueprintSales /></Shell>} />
            <Route path="/blueprint/console" element={<BlueprintConsole />} />
            <Route path="/newsletter" element={<Shell><Newsletter /></Shell>} />
            <Route path="/waitlist" element={<Shell><Waitlist /></Shell>} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/email-preferences" element={<EmailPreferences />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
    </HelmetProvider>
  );
}

export default App;
